export default __webpack_public_path__ + "fonts/h5banner.d51ea2aa62d6eaa6473ced7521ddf740.jpg";